import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import AppUtil from "utilities/AppUtil";
import httpRequest from "../../services/httpRequest";
import { getMe, saveAuthToken } from "./auth";
import snakecaseKeys from 'snakecase-keys';
// Main URL Endpoint
const _urlPrefix = "/worker";

export const reduceSignupWorker = createAsyncThunk(
  "worker/reduceSignupWorker",
  async (params, { dispatch }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/sign-up-id-password`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.signup.200"
    });
    if (!result) {
      return;
    }
    dispatch(saveAuthToken({
      accessToken: result.data.accessToken,
      expireDate: result.data.expireDate
    }));
    return result.data;
  }
);
export const reduceSignupAppleWorker = createAsyncThunk(
    "worker/reduceSignupAppleWorker",
    async (params, { dispatch }) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/sign-up-apple`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: "toast.signup.200"
        });
        if (!result) {
            return;
        }
        dispatch(saveAuthToken({
            accessToken: result.data.accessToken,
            expireDate: result.data.expireDate
        }));
        return result.data;
    }
);
export const reduceSignupGoogleWorker = createAsyncThunk(
  "worker/reduceSignupGoogleWorker",
  async (params, { dispatch }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/sign-up-google`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.signup.200"
    });
    if (!result) {
      return;
    }
    dispatch(saveAuthToken({
      accessToken: result.data.accessToken,
      expireDate: result.data.expireDate
    }));
    return result.data;
  }
);
export const reduceSignupFacebookWorker = createAsyncThunk(
  "worker/reduceSignupFacebookWorker",
  async (params, { dispatch }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/sign-up-facebook`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.signup.200"
    });
    if (!result) {
      return;
    }
    dispatch(saveAuthToken({
      accessToken: result.data.accessToken,
      expireDate: result.data.expireDate
    }));
    return result.data;
  }
);
export const fetchSpecialties = createAsyncThunk(
  "worker/fetchSpecialties",
  async () => {
    const result = await httpRequest({
      url: 'specialty/list',
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchLanguages = createAsyncThunk(
  "worker/fetchLanguages",
  async () => {
    const result = await httpRequest({
      url: 'language/list',
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchSupports = createAsyncThunk(
  "worker/fetchSupports",
  async () => {
    const result = await httpRequest({
      url: 'support/list',
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchAccreditation = createAsyncThunk(
  "worker/fetchAccreditation",
  async (params) => {
    const result = await httpRequest({
      url: 'accreditation/list',
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const updateAgreement = createAsyncThunk(
  "worker/updateAgreement",
  async (params, { dispatch }) => {
    const {
      id,
      agreementForTaxFile,
      agreementFile,
      isGetMe
    } = params;

    const data = new FormData();

    agreementForTaxFile && data.append('agreement_for_tax_file ', agreementForTaxFile);
    agreementFile && data.append('agreement_file ', agreementFile);
    const result = await httpRequest({
      url: `${_urlPrefix}/update/agreement/${id}`,
      method: "PUT",
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: data,
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    if (isGetMe) {
      dispatch(getMe());
    }
    return result.data;
  }
);
export const updateCompliance = createAsyncThunk(
  "worker/updateCompliance",
  async ({ id, formData, disableSuccessMessage = false }) => {
    console.log(' >>> formData: ', formData);
    const result = await httpRequest({
      url: `${_urlPrefix}/update/compliance/${id}`,
      method: "PUT",
      data: formData,
      successMessage: disableSuccessMessage ? false : "toast.update.200"
    });
    if (!result) return;
    return result.data;
  }
);

export const updateStatusFileTraining = createAsyncThunk(
  "worker/updateStatusFileTraining",
  async ({ type, fileId, status, disableSuccessMessage = false, workerId }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/status-file-training`,
      method: "PUT",
      params: { type },
      data: snakecaseKeys({ fileId, status, workerId }),
      successMessage: disableSuccessMessage ? false : "toast.update.200"
    });
    if (!result) return;
    return result.data;
  }
);

export const updateDocument = createAsyncThunk(
  "worker/updateDocument",
  async ({ id, formData, disableSuccessMessage = false }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/update/documents/${id}`,
      method: "PUT",
      data: formData,
      successMessage: disableSuccessMessage ? false : "toast.update.200"
    });
    if (!result) return;
    return result.data;
  }
);

export const updateStatusFileDocuments = createAsyncThunk(
  "worker/updateStatusFileDocuments",
  async ({ type, fileId, status, disableSuccessMessage = false }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/status-file-documents`,
      method: "PUT",
      params: { type },
      data: snakecaseKeys({ fileId, status }),
      successMessage: disableSuccessMessage ? false : "toast.update.200"
    });
    if (!result) return;
    return result.data;
  }
);

export const updateWorkAndPay = createAsyncThunk(
  "worker/updateWorkAndPay",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/update/work-and-pay`,
      method: "PUT",
      data: snakecaseKeys(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const updateAvatar = createAsyncThunk(
  "worker/updateAvatar",
  async (params) => {
    const { file, contentData } = params;
    const data = new FormData();
    if (file) {
      data.append('avatar', file);
    }
    data.append('content-data', new Blob([JSON.stringify(snakecaseKeys(contentData))], {
      type: 'application/json'
    }));
    const result = await httpRequest({
      url: `${_urlPrefix}/update/personal-info`,
      method: "PUT",
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: data,
      successMessage: "toast.update.200"
    });
    if (!result) return;
    return result.data;
  }
);

export const updatePersonalInfo = createAsyncThunk(
  "worker/updatePersonalInfo",
  async (params) => {
    const { contentData } = params;
    const data = new FormData();
    data.append('content-data', new Blob([JSON.stringify(snakecaseKeys(contentData))], {
      type: 'application/json'
    }));
    const result = await httpRequest({
      url: `${_urlPrefix}/update/personal-info`,
      method: "PUT",
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: data,
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const updateProfessionalInfo = createAsyncThunk(
  "worker/updateProfessionalInfo",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/update/professional-info`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const updateBankAccount = createAsyncThunk(
  "worker/updateBankAccount",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/update/bank-account`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const updateVerification = createAsyncThunk(
  "worker/updateVerification",
  async (params) => {
    const {
      id,
      aphraRegistrationNumber,
      isCompletedNdisChecking,
      referenceRequests,
      // registrationNumberFile,
      certificationFileList,
      aphraRegistrationFileList,
      policeCheckFileList,
      workingWithChildrenFileList,
      cprFileList,
      ndisOrientationModuleList,
      infectionControlList,
      carRegistrationList,
      resumeList,
      comprehensiveInsuranceList,
      otherList
    } = params;
    const data = new FormData();
    const contentData = {
      aphraRegistrationNumber,
      isCompletedNdisChecking,
      referenceRequests
    };
    if (certificationFileList) {
      for (let i = 0 ; i < certificationFileList.length ; i++) {
        data.append('certification_file_list', certificationFileList[i]);
      }
    }
    if (aphraRegistrationFileList) {
      for (let i = 0 ; i < aphraRegistrationFileList.length ; i++) {
        data.append('aphra_registration_file_list', aphraRegistrationFileList[i]);
      }
    }
    if (policeCheckFileList) {
      for (let i = 0 ; i < policeCheckFileList.length ; i++) {
        data.append('police_check_file_list', policeCheckFileList[i]);
      }
    }
    if (workingWithChildrenFileList) {
      for (let i = 0 ; i < workingWithChildrenFileList.length ; i++) {
        data.append('working_with_children_file_list', workingWithChildrenFileList[i]);
      }
    }
    if (cprFileList) {
      for (let i = 0 ; i < cprFileList.length ; i++) {
        data.append('cpr_file_list', cprFileList[i]);
      }
    }
    if (ndisOrientationModuleList) {
      for (let i = 0 ; i < ndisOrientationModuleList.length ; i++) {
        data.append('ndis_orientation_module_list', ndisOrientationModuleList[i]);
      }
    }
    if (infectionControlList) {
      for (let i = 0 ; i < infectionControlList.length ; i++) {
        data.append('infection_control_list', infectionControlList[i]);
      }
    }
    if (carRegistrationList) {
      for (let i = 0 ; i < carRegistrationList.length ; i++) {
        data.append('car_registration_list', carRegistrationList[i]);
      }
    }
    if (resumeList) {
      for (let i = 0 ; i < resumeList.length ; i++) {
        data.append('resume_list', resumeList[i]);
      }
    }
    if (comprehensiveInsuranceList) {
      for (let i = 0 ; i < comprehensiveInsuranceList.length ; i++) {
        data.append('comprehensive_insurance_list', comprehensiveInsuranceList[i]);
      }
    }
    if (otherList) {
      for (let i = 0 ; i < otherList.length ; i++) {
        data.append('other_list', otherList[i]);
      }
    }
    data.append('content-data', new Blob([JSON.stringify(snakecaseKeys(contentData))], {
      type: 'application/json'
    }));
    const result = await httpRequest({
      url: `${_urlPrefix}/update/verification/${id}`,
      method: "PUT",
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: data,
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerDetail = createAsyncThunk(
  "worker/fetchWorkerDetail",
  async (params) => {
    const { workerId } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/public/detail/${workerId}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerListPaging = createAsyncThunk(
  "worker/fetchWorkerListPaging",
  async (params) => {
    const result = await httpRequest({
      url: _urlPrefix,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerOptionsList = createAsyncThunk(
  "worker/fetchWorkerOptionsList",
  async (params) => {
    const result = await httpRequest({
      url: _urlPrefix,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerListByBillingId = createAsyncThunk(
  "worker/fetchWorkerListByBillingId",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/list`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const createWorker = createAsyncThunk(
  "worker/createWorker",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/create`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.create.worker"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const activeWorker = createAsyncThunk(
  "worker/activeWorker",
  async (params) => {
    const { workerId } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/${workerId}`,
      method: "PUT",
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const terminateWorker = createAsyncThunk(
  "worker/terminateWorker",
  async (params) => {
    const { workerId, data } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/${workerId}/status`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(data),
      successMessage: "toast.update.200"
    });
    console.log('result', result);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const deactivateWorker = createAsyncThunk(
  "worker/deactivateWorker",
  async (params) => {
    const { workerId, data } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/${workerId}/status`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(data),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reactivateWorker = createAsyncThunk(
  "worker/reactivateWorker",
  async (params) => {
    const { workerId, data } = params;
    console.log('data', data);
    const result = await httpRequest({
      url: `${_urlPrefix}/${workerId}/status`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(data),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const verifyWorker = createAsyncThunk(
  "worker/verifyWorker",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/verify-on-board`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerFeedback = createAsyncThunk(
  "worker/fetchWorkerFeedback",
  async (params) => {
    const { workerId } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/on-board-feedbacks/${workerId}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const deleteWorker = createAsyncThunk(
  "worker/deleteWorker",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/delete`,
      data: AppUtil.toSnakeCaseKey(params),
      method: "DELETE",
      successMessage: 'toast.remove.200'
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const deleteFilesVerification = createAsyncThunk(
  "worker/deleteFilesVerification",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/delete-file-verification`,
      data: AppUtil.toSnakeCaseKey(params),
      method: "DELETE",
      successMessage: 'toast.remove.200'
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceSearchWorker = createAsyncThunk(
  "worker/reduceSearchWorker",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/search`,
      params: AppUtil.toSnakeCaseKey(params),
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerList = createAsyncThunk(
  "worker/fetchWorkerList",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/list`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchWorkerListByPayroll = createAsyncThunk(
  "worker/fetchWorkerListByPayroll",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/get-worker-list-for-payroll`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchSuperFunds = createAsyncThunk(
  "worker/fetchSuperFunds",
  async () => {
    const result = await httpRequest({
      url: `${_urlPrefix}/super-funds`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reduceUpdateWorkerNotifyEmail = createAsyncThunk(
  "worker/reduceUpdateWorkerNotifyEmail",
  async (params) => {
      const result = await httpRequest({
          url: `${_urlPrefix}/update/notify-email`,
          data: AppUtil.toSnakeCaseKey(params),
          method: "PUT",
          successMessage: 'toast.update.200'
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

export const reduceGetAllWorker = createAsyncThunk(
  "worker/reduceGetAllWorker",
  async () => {
    const result = await httpRequest({
      url: `${_urlPrefix}/get-all`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reduceGetAllWorkerHasBooking = createAsyncThunk(
  "worker/reduceGetAllWorkerHasBooking",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/get-all-worker-has-booking`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceGetAllWorkerProgressNote = createAsyncThunk(
  "worker/reduceGetAllWorkerProgressNote",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/get-all-worker-process-note`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reSendEmailUpdateInfo = createAsyncThunk(
  "worker/reSendEmailUpdateInfo",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/resend-email-update-infor`,
      method: "PUT",
      data: snakecaseKeys(params),
      successMessage: "toast.update.resendEmail"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const resendOnboarding = createAsyncThunk(
  "worker/resendOnboarding",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/resend-onboarding`,
      method: "PUT",
      data: snakecaseKeys(params),
      successMessage: "toast.update.resendEmail"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  info: {},
  specialties: [],
  languages: [],
  supports: [],
  accreditations: [],
  detail: {},
  list: [],
  activeTab: 0,
  complianceMatrixPage: 1,
  complianceMatrixSearchKey: "",
  complianceMatrixRagFilter: "",
  listPaging: {
    queries: {
      page: 1,
      size: 10,
      search_key: "",
      sort_field: "createdDate",
      asc_sort: false,
      statuses: undefined,
      approvalStatus: undefined,
    },
    totalElements: 0,
    totalPages: 0,
  },
  searchWorker: {
    queries: {
      page: 1,
      size: 20,
      accreditationIds: [],
      genders: [],
      languageIds: [],
      lat: '',
      lng: '',
      specialtyIds: [],
      supportIds: [],
      search: ''
    },
    totalElements: 0,
    totalPages: 0,
    list: []
  },
  listAll: [],
  listHasBooking: [],
  listWrorkerProgressNote: []
};

const worker = createSlice({
  name: "worker",
  initialState: initialState,
  reducers: {
    setSearchWorkerQueries: (state, { payload }) => {
      state.searchWorker = {
        ...state.searchWorker,
        queries: payload
      };
    },
    removeSearchWorkerQueries: (state) => {
      state.searchWorker = initialState.searchWorker;
    },
    setWorkerListPagingQueries: (state, { payload }) => {
      state.listPaging.queries = { ...state.listPaging.queries, ...payload };
    },
    resetWorkerListPaging: (state) => {
      state.listPaging = { ...initialState.listPaging };
    },
    setWorkerActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    setComplianceMatrixPage: (state, { payload }) => {
      state.complianceMatrixPage = payload;
    },
    setComplianceMatrixSearchKey: (state, { payload }) => {
      state.complianceMatrixSearchKey = payload;
    },
    setComplianceMatrixRagFilter: (state, { payload }) => {
      state.complianceMatrixRagFilter = payload;
    },
  },
  extraReducers: {
    [fetchWorkerDetail.fulfilled]: (state, action) => {
      if (action.payload) {
        state.detail = action.payload;
        for (const key in state.detail) {
          if (state.detail[key] === null || state.detail[key] === undefined) {
            state.detail[key] = '';
          }
        }
      }
    },
    [fetchSpecialties.fulfilled]: (state, action) => {
      if (action.payload) {
        state.specialties = action.payload.map(item => {
          item.label = item.name;
          return item;
        });
      }
    },
    [fetchLanguages.fulfilled]: (state, action) => {
      if (action.payload) {
        state.languages = action.payload.map(item => {
          item.label = item.language;
          return item;
        });
      }
    },
    [fetchSupports.fulfilled]: (state, action) => {
      if (action.payload) {
        state.supports = action.payload.map(item => {
          item.label = item.name;
          return item;
        });
      }
    },
    [fetchAccreditation.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.accreditations = payload;
      }
    },
    [fetchWorkerListPaging.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.list = payload.content;
        state.listPaging.totalElements = payload.totalElements || 0;
        state.listPaging.totalPages = payload.totalPages || 0;
      }
    },
    [reduceSearchWorker.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.searchWorkerList = payload.content;
        state.searchWorker = {
          ...state.searchWorker,
          list: payload.content,
          totalElements: payload.totalElements,
          totalPages: payload.totalPages
        };
      }
    },
    [reduceGetAllWorker.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.listAll = payload;
      }
    },
    [reduceGetAllWorkerHasBooking.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.listHasBooking = payload;
      }
    },
    [reduceGetAllWorkerProgressNote.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.listWrorkerProgressNote = payload;
      }
    }
  }
});

const { reducer, actions } = worker;
export const { setSearchWorkerQueries, removeSearchWorkerQueries, setWorkerListPagingQueries, resetWorkerListPaging, setWorkerActiveTab, setComplianceMatrixPage, setComplianceMatrixSearchKey, setComplianceMatrixRagFilter } = actions;
export default reducer;

export const getWorkerDetail = createSelector(
  (state) => state.worker.detail,
  (worker) => worker
);

export const getAllWorker = createSelector(
  (state) => state.worker.listAll,
  (listAll) => listAll
);
export const getSpecialties = createSelector(
  (state) => state.worker.specialties,
  (specialties) => specialties
);
export const getLanguages = createSelector(
  (state) => state.worker.languages,
  (languages) => languages
);
export const getSupports = createSelector(
  (state) => state.worker.supports,
  (supports) => supports
);
export const getWorkerList = createSelector(
  state => state.worker.list,
  list => list
);
export const getAccreditations = createSelector(
  state => state.worker.accreditations,
  accreditations => accreditations
);

export const getSearchWorkerQueries = createSelector(
  state => state.worker.searchWorker.queries,
  queries => queries
);

export const getSearchWorkerList = createSelector(
  state => state.worker.searchWorker.list,
  searchWorkerList => searchWorkerList
);

export const getSearchWorkerTotalElements = createSelector(
  state => state.worker.searchWorker.totalElements,
  totalElements => totalElements
);

export const getSearchWorkerTotalPages = createSelector(
  state => state.worker.searchWorker.totalPages,
  totalPages => totalPages
);

export const getAllWorkers = createSelector(
  state => state.worker.listAll,
  listAll => listAll
);

export const getAllWorkersHasBooking = createSelector(
  state => state.worker.listHasBooking,
  listHasBooking => listHasBooking
);

export const getAllWorkersProgressNote = createSelector(
  state => state.worker.listWrorkerProgressNote,
  listWrorkerProgressNote => listWrorkerProgressNote
);

export const getWorkerListPaging = createSelector(
  state => state.worker.listPaging,
  listPaging => listPaging
);

export const getWorkerActiveTab = createSelector(
  state => state.worker.activeTab,
  activeTab => activeTab
);

export const getComplianceMatrixPage = createSelector(
  state => state.worker.complianceMatrixPage,
  complianceMatrixPage => complianceMatrixPage
);

export const getComplianceMatrixSearchKey = createSelector(
  state => state.worker.complianceMatrixSearchKey,
  complianceMatrixSearchKey => complianceMatrixSearchKey
);

export const getComplianceMatrixRagFilter = createSelector(
  state => state.worker.complianceMatrixRagFilter,
  complianceMatrixRagFilter => complianceMatrixRagFilter
);